/**
 * This function is used on thank you pages (once donation is completed), to send donation completed event to GTM
 * It checks if the entryId is already sent to GTM, if not, it sends the event and adds the entryId to the localStorage
 *
 * @returns {void}
 */
function donationCompletedGTM() {
  const entryId = sessionStorage.getItem("entryId");
  if (!entryId) {
    return;
  }
  let sentEntries = localStorage.getItem("sentEntries");
  if (!sentEntries) {
    localStorage.setItem("sentEntries", JSON.stringify([]));
    sentEntries = [];
  } else {
    try {
      sentEntries = JSON.parse(sentEntries);
    } catch (error) {
      sentEntries = [];
    }
  }
  if (!Array.isArray(sentEntries)) {
    sentEntries = [];
  }
  if (sentEntries.includes(entryId)) {
    return;
  }
  sentEntries.push(entryId);
  const donationType = sessionStorage.getItem("donationType");
  if (!donationType) {
    return;
  }
  const donationAmount = sessionStorage.getItem("donationAmount");
  if (!donationAmount) {
    return;
  }
  let eventName = "";
  switch (donationType) {
    case "aineeton-lahja":
    case "immateriell-gava":
      eventName = "aineeton_donation_completed";
      break;
    case "yrityslahjoitus":
    case "corporate-donation":
    case "foretagsgava":
      eventName = "yrityslahjoitus_donation_completed";
      break;
    case "yksityislahjoitus":
    case "ge-en-gava":
    case "donation":
      eventName = "yksityislahjoitus_donation_completed";
      break;
    default:
      eventName = "donation_completed";
      break;
  }
  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "donation_completed",
    analytics_event_name: eventName,
    donation_amount: donationAmount,
    donation_type: donationType,
  });
  localStorage.setItem("sentEntries", JSON.stringify(sentEntries));
  sessionStorage.removeItem("entryId");
}
window.donationCompletedGTM = donationCompletedGTM;
